import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketInsights = ({ insights }) => {
  const getInsightIcon = (type) => {
    switch (type) {
      case 'price': return 'TrendingUp';
      case 'demand': return 'Users';
      case 'competition': return 'Target';
      case 'timing': return 'Clock';
      default: return 'Info';
    }
  };

  const getInsightColor = (impact) => {
    switch (impact) {
      case 'positive': return 'text-success bg-green-50 border-green-200';
      case 'negative': return 'text-error bg-red-50 border-red-200';
      case 'neutral': return 'text-warning bg-yellow-50 border-yellow-200';
      default: return 'text-text-secondary bg-muted border-border';
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };

  return (
    <div className="bg-surface rounded-lg border border-border p-6 shadow-property-card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-text-primary">Market Insights</h3>
        <Icon name="TrendingUp" size={20} className="text-primary" />
      </div>
      
      <div className="space-y-4">
        {insights.map((insight, index) => (
          <div key={index} className={`p-4 rounded-lg border ${getInsightColor(insight.impact)}`}>
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <Icon name={getInsightIcon(insight.type)} size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold mb-1">{insight.title}</h4>
                <p className="text-sm mb-2">{insight.description}</p>
                
                {insight.recommendation && (
                  <div className="bg-white bg-opacity-50 rounded p-2 mt-2">
                    <p className="text-xs font-medium">Recommendation:</p>
                    <p className="text-xs">{insight.recommendation}</p>
                  </div>
                )}
                
                {insight.metrics && (
                  <div className="flex items-center space-x-4 mt-2 text-xs">
                    {insight.metrics.map((metric, metricIndex) => (
                      <div key={metricIndex} className="flex items-center space-x-1">
                        <span className="font-medium">{metric.label}:</span>
                        <span>
                          {metric.type === 'currency' ? formatCurrency(metric.value) : metric.value}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-4 p-3 bg-muted rounded-lg">
        <div className="flex items-center space-x-2 text-sm text-text-secondary">
          <Icon name="Info" size={16} />
          <span>Insights updated daily based on market trends and property performance</span>
        </div>
      </div>
    </div>
  );
};

export default MarketInsights;